import React from 'react';
import styles from './AuthAlert.module.scss';
import IconWarning from '@material-ui/icons/WarningRounded';

type Props = {
  alert?: string;
};

const AuthAlert: React.FC<Props> = ({ alert }) => {
  return (
    <div className={styles.container}>
      <IconWarning />
      {alert}
    </div>
  );
};

export default AuthAlert;
